module.exports = __webpack_public_path__ + "img/grunt.1d815821.png";